import axios from 'axios'

export default {
  changePrices (prices) {
    return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/prices', prices).then((response) => {
      return response
    })
  }
}
